"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebComponent = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var shared_1 = require("@cian/peperrors/shared");
var serialize_1 = require("../../shared/parameters/serialize");
var constants_1 = require("../../shared/webComponent/constants");
var ERROR_DOMAIN = 'mf-registry.browser.WebComponent';
/**
 * Вспомогательный абстрактный класс с реализацией минимального жизненного цикла
 * * render
 * * didMount
 * * render
 * * didUpdate
 * * willUnmount
 *
 * @export
 * @abstract
 * @class WebComponent
 * @extends {HTMLElement}
 * @template T
 */
var WebComponent = /** @class */ (function (_super) {
    __extends(WebComponent, _super);
    function WebComponent() {
        var _this = _super.call(this) || this;
        _this.__parameters = null;
        _this.__inConstructor = true;
        _this.__isMounted = false;
        _this.__update();
        _this.__inConstructor = false;
        return _this;
    }
    Object.defineProperty(WebComponent, "observedAttributes", {
        get: function () {
            return [constants_1.PARAMETERS_ATTRIBUTE];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebComponent.prototype, "parameters", {
        get: function () {
            var __parameters = this.__parameters;
            if (__parameters) {
                return __parameters;
            }
            throw new shared_1.ConfigurationError({
                message: 'Can not get parameters before call super()',
                domain: ERROR_DOMAIN,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebComponent.prototype, "isMounted", {
        /**
         * Признак того, что компонента замаунчена
         *
         * @readonly
         * @protected
         * @type {boolean}
         * @memberof WebComponent
         */
        get: function () {
            return this.__isMounted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebComponent.prototype, "shouldHydrate", {
        /**
         * Признак того, что необходима гидрация:
         * * Компонента не замаунчена
         * * Есть контент внутри рута
         *
         * @readonly
         * @protected
         * @type {boolean}
         * @memberof WebComponent
         */
        get: function () {
            return !this.isMounted && !!this.root.innerHTML;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebComponent.prototype, "root", {
        /**
         * Элемент в который нужно рендерить контент
         *
         * @readonly
         * @protected
         * @type {HTMLElement}
         * @memberof WebComponent
         */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Вызывается после каждого первого рендера после вставки в DOM
     * В процессе connectedCallback
     *
     * @protected
     * @memberof WebComponent
     */
    WebComponent.prototype.didMount = function () { };
    /**
     * Вызывается после повторного рендера, когда параметры изменились
     * В процессе attributeChangedCallback
     *
     * В первом аргументе предыдущие параметры
     *
     * @protected
     * @param {T} prevParameters
     * @memberof WebComponent
     */
    WebComponent.prototype.didUpdate = function (prevParameters) { };
    /**
     * Вызывается когда как элемент покинул DOM
     * В процессе disconnectedCallback
     *
     * @protected
     * @memberof WebComponent
     */
    WebComponent.prototype.willUnmount = function () { };
    WebComponent.prototype.attributeChangedCallback = function () {
        this.__update();
    };
    WebComponent.prototype.connectedCallback = function () {
        this.__mount();
    };
    WebComponent.prototype.disconnectedCallback = function () {
        this.__unmount();
    };
    WebComponent.prototype.__mount = function () {
        this.render();
        this.__isMounted = true;
        this.didMount();
    };
    WebComponent.prototype.__unmount = function () {
        this.willUnmount();
        this.__isMounted = false;
    };
    WebComponent.prototype.__update = function () {
        var parametersString = this.getAttribute(constants_1.PARAMETERS_ATTRIBUTE);
        var nextParameters = parametersString ? (0, serialize_1.parseParameters)(parametersString) : null;
        if (!this.__inConstructor && nextParameters === null) {
            throw new shared_1.ValidationError({
                message: 'Parameters is not defined in attributes',
                domain: ERROR_DOMAIN,
            });
        }
        var prevParameters = this.__parameters;
        this.__parameters = nextParameters;
        if (this.isMounted) {
            this.render();
            this.didUpdate(prevParameters);
        }
    };
    return WebComponent;
}(HTMLElement));
exports.WebComponent = WebComponent;
//# sourceMappingURL=WebComponent.js.map